enum HorizontalDirection {
  LEFT = -1,
  RIGHT = 1,
}

export default HorizontalDirection;
